var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "social-tiktok",
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "social-circle",
    cx: 22,
    cy: 22,
    r: 22,
    fill: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "social-icon",
    d: "M19.56,19.36v-1a3.36,3.36,0,0,0-1-.09,7.59,7.59,0,0,0-4.36,13.8L14.12,32a7.33,7.33,0,0,1-1.9-5,7.52,7.52,0,0,1,7.34-7.59Z",
    fill: "#25f4ee"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "social-icon",
    d: "M19.73,30.42A3.47,3.47,0,0,0,23.2,27V10.52h3a4.26,4.26,0,0,1-.08-1.07H22V26a3.45,3.45,0,0,1-3.47,3.31A3.21,3.21,0,0,1,17,28.89,3.52,3.52,0,0,0,19.73,30.42ZM31.87,16.14v-1a5.83,5.83,0,0,1-3.14-.91A5.92,5.92,0,0,0,31.87,16.14Z",
    fill: "#25f4ee"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "social-icon",
    d: "M28.73,14.24a5.52,5.52,0,0,1-1.4-3.8H26.17A6,6,0,0,0,28.73,14.24ZM18.57,22.33a3.48,3.48,0,0,0-3.46,3.47A3.54,3.54,0,0,0,17,28.85a3.35,3.35,0,0,1-.66-2,3.49,3.49,0,0,1,3.47-3.47,4.27,4.27,0,0,1,1,.17V19.36a4.18,4.18,0,0,0-1-.08h-.16v3.13C19.23,22.41,18.9,22.33,18.57,22.33Z",
    fill: "#fe2c55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "social-icon",
    d: "M31.87,16.14v3.14a9.63,9.63,0,0,1-5.7-1.82v8.42a7.58,7.58,0,0,1-7.56,7.6h0a7.88,7.88,0,0,1-4.37-1.32A7.6,7.6,0,0,0,27.33,27V18.53A9.94,9.94,0,0,0,33,20.35V16.22A6.08,6.08,0,0,1,31.87,16.14Z",
    fill: "#fe2c55"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "social-icon",
    d: "M26.17,25.88V17.46a10,10,0,0,0,5.7,1.82V16.06a5.71,5.71,0,0,1-3.14-1.82,5.52,5.52,0,0,1-2.48-3.8H23.2V27a3.47,3.47,0,0,1-3.47,3.31,3.58,3.58,0,0,1-2.81-1.41,3.25,3.25,0,0,1-1.81-3,3.48,3.48,0,0,1,3.46-3.47,4.27,4.27,0,0,1,1,.17V19.36a7.59,7.59,0,0,0-5.36,12.8,7.88,7.88,0,0,0,4.37,1.4A7.76,7.76,0,0,0,26.17,25.88Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.986c4cba27bbe0d748708360c6fc73bb.svg";
export { ForwardRef as ReactComponent };